<template>
  <chart :options="options" />
</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/variable-pie'
exportingInit(Highcharts)

export default {
  components: {
    Chart
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    },
    label: {
      type: Boolean,
      default: true
    },
    symbol: {
      type: String,
      default: 'TL'
    }
  },
  data() {
    return {
      options: {
        colors: ['#13a2e8', '#00df9a', '#164194', '#ffbe3c', '#002c65'],
        chart: {
          width: this.width,
          height: this.height,
          type: 'bar',
          style: {
            fontFamily: 'BwGlennSans-Regular',
            fontSize: '16px'
          }
        },
        title: {
          text: '',
          style: {
            display: 'none'
          }
        },
        subtitle: {
          text: '',
          style: {
            display: 'none'
          }
        },
        xAxis: {
          categories: this.data.categories,
          labels: {
            style: {
              fontFamily: 'BwGlennSans-Regular',
              fontSize: '13px'
            }
          },
          title: {
            text: null
          }
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        tooltip: {
          pointFormat: '<span style="color:{point.color}">{series.name}</span>: {point.y} ' + this.symbol,
          style: {
            fontFamily: 'BwGlennSans-Regular',
            fontSize: '14px'
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: this.label
            }
          }
        },
        series: [
          {
            colorByPoint: true,
            name: this.data.series.name,
            data: this.data.series.data
          }
        ],
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        }
      }
    }
  }
}
</script>